import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { BaasLink } from '../../../../baas-link/baas-link';
import { BaasExternalLinkGroupOptions } from '../../../baas-external-link-group-options.type';

@Component({
    selector: 'baas-layout-menu-external-links',
    templateUrl: './baas-layout-menu-external-links.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BaasLink]
})
export class BaasLayoutMenuExternalLinksComponent {
    readonly items = input<BaasExternalLinkGroupOptions[]>(undefined);
}
